import React, { useEffect, useState } from 'react';
import logo from './company-logo.png';
//import logo from './logo.svg';
import './App.css';
import InformationDisplay from './InformationDisplay';
import ErrorMessageDisplay from './ErrorMessageDisplay';
import OutputItems from './OutputItems';
import { Box, Chip, CircularProgress, Divider, Stack, TextField, Typography, Link } from '@mui/material';
//import { Helmet, HelmetProvider } from 'react-helmet-async';
import axios from 'axios';

import { useLinkedIn } from './component/my-oauth2/useLinkedIn';
//import {getLinkedInProfile} from './component//my-oauth2/getLinkedInProfile'; //don't need this
import linkedin from './component/assets/linkedin.png';


import {
    clientId,
    redirectUri,
    generalInstructionsOnUseOfTool,
    linkedInLoginSuggestion,
    liUserProfileUrl,
    w2sqlUrl
} from './component/settings-code';
//import { redirect } from 'react-router-dom';

let instructionsOnUseOfTool;

//const userProfileUrlOld = "https://274mcosd36l7ipxqbgfvknbmv40flfet.lambda-url.us-east-1.on.aws/";

function AppMain() {
    const [code, setCode] = useState('');
    const [value, setValue] = useState({});
    const [userProfile, setUserProfile] = useState({});
    const [showProgress, setShowProgress] = useState(false);

    const fetchUserProfile = (acode) => {
        setShowProgress(true);
        // console.log("fetching profile from: "+redirectUri);
        // console.log("fetching profile: liUserProfileUrl: " + liUserProfileUrl + ", redirectUri:"+redirectUri);

        // Below line should be uncommented only for development related debugging.
        // In production, below line will be a security risk as any user will be able to see auth code on
        // browser console.
        // console.log("(Auth) code: "+code)

        axios
            .post(liUserProfileUrl, { code: acode, redirect_uri: redirectUri })
            .then(response => {
                // Below lines should be uncommented only for development related debugging.
                // In production, below line will be a security risk as any user will be able to see auth code on
                // browser console. body object has acd member which has auth code.
                // console.log("response.data.body=");
                // console.log(response.data.bdoy);
                return response.data.body;
            })
            .then(profile => { 
                // console.log("profile=" + profile); 
                setUserProfile(profile); setShowProgress(false); 
            })
            .catch(err => {
                setShowProgress(false);
                console.log("\nError getting LinkedIn Profile from server " + err);
            });
    }

    useEffect(() => {
        if (code !== '') {
            // console.log("fetching profile");
            fetchUserProfile(code);
        }
    }, [code]);

    // console.log ("redirectUri will be set as: " + `${window.location.origin}/linkedin`);
    const { linkedInLogin } = useLinkedIn({
        clientId: clientId,
        redirectUri:`${window.location.origin}/linkedin`,
        onSuccess: (code) => {
            // console.log("setting code");
            setCode(code);
            value.sessionId = code;
            setValue(value);
        },
        onError: (error) => {
          console.log(error);
        },
    });

    instructionsOnUseOfTool = (code === undefined) ? generalInstructionsOnUseOfTool : generalInstructionsOnUseOfTool + linkedInLoginSuggestion;

    const getData = (payload) => {
        setShowProgress(true);
        axios
            .post(w2sqlUrl, { ...payload, ...userProfile })
            .then(res => {
                return JSON.parse(res.data.body);
            })
            .then(response => {
                //check for response.exception. If populated, extract exception and display
                //otherwise do the processing as given below
                if (response.exception == undefined) {
                let mappletNames = new Set(response.stats.slice().filter(e => e.type === "Mapplet").map(e => e.model));
                let total_complexity=
                response.stats.slice().filter(e => mappletNames.has(e.model)).filter(e => e.avg_complexity > 0).reduce((accumulator, current) => accumulator + current.avg_complexity, 0)
                +
                response.stats.slice().filter(e => !mappletNames.has(e.model)).filter(e => e.avg_complexity > 0).reduce((accumulator, current) => accumulator + current.avg_complexity, 0)
                ;
                let tf = false;
                if (total_complexity>200)
                    tf = true;
                setValue({
                    sessionId: value.sessionId,
                    preamble: response.preamble,
                    stats: response.stats,
                    needProperAuth: response.needProperAuth,
                    isSuccessful: response.isSuccessful,
                    sequenceSqlList: response.sequenceSqlList,
                    cteSqlList: response.cteSqlList,
                    targetSqlList: response.targetSqlList,
                    xml: value.xml,
                    exception: response.exception,
                    needsCorporateLogin: tf
                });
            } else {
                setValue({
                    sessionId: value.sessionId,
                    preamble: response.preamble,
                    stats: response.stats,
                    needProperAuth: response.needProperAuth,
                    isSuccessful: response.isSuccessful,
                    sequenceSqlList: response.sequenceSqlList,
                    cteSqlList: response.cteSqlList,
                    targetSqlList: response.targetSqlList,
                    xml: value.xml,
                    exception: response.exception,
                    needsCorporateLogin: undefined
                });
            }
                setShowProgress(false);
            })
            .catch(err => { console.log("error: " + err); setShowProgress(false); console.log("got error back"); })
            ;
    }

    const handleGetSQLClick = (target) => {
        if (value.xml === undefined || value.xml.length === 0) {
            alert("Please enter your workflow XML and then click the button.");
        } else {
            value.sessionId = (code === undefined || code.length === 0) ? "anonymous" : code;
            getData({ sessionId: value.sessionId, targetPlatform: target, xml: value.xml });
        }
    }
    const handleViewTerms = () => {
        window.open("https://agility1st.com/terms-of-use-disclaimer", '_blank', 'left=200,top=200,width=900,height=500');
    }
    const handleContactus = () => {
        window.open("https://agility1st.com/#contact", '_blank', 'left=200,top=200,width=900,height=500');
    }
    const handleUsefulBlog = () => {
        window.open("https://agility1st.com/learn-how-w2sql-works", '_blank', 'left=200,top=200,width=900,height=500');
    }
    const handleSparkClick = () => {
        handleGetSQLClick("spark");
    }
    const handleSnowflakeClick = () => {
        handleGetSQLClick("snowflake");
    }

    const handleXMLChange = (event) => {
        setValue({ ...value, xml: event.target.value });
    }
    const handleReset = (event) => {
        let auth = (code !== undefined) ? false : undefined;
        let resetState = {sessionId: value.sessionId, stats: undefined, needProperAuth: auth, isSuccessful: undefined, sequenceSqlList: undefined, cteSqlList: undefined, targetSqlList: undefined, xml: ""};
        setValue(resetState);
    }
    const getStyleForInputXML = () => {
        const fsize = value.xml && value.xml.length > 0 ? 10 : 14;
        //earlier it was: const possibly without semicolon and style: { fontFamily: 'monospace', lineHeight: 1.5, fontSize: fsize, }
        //now not changing the font size and keeping it monospace always.
        return {
            spellCheck: false,
            'data-gramm': 'false',
            'data-gramm_editor': 'false',
            'data-enable-grammarly': 'false',
            style: { fontFamily: 'monospace', lineHeight: 1.5 }
        };
    }
    const handleShowDemo = () => {
        window.open("https://www.linkedin.com/feed/update/urn:li:activity:6753453871739215872", '_blank', 'left=200,top=200,width=500,height=500');
    }

  return (
    <div className="App">
          <div className="App-header">
              {
                  !code &&
                      <img
                          onClick={linkedInLogin}
                          src={linkedin}
                          alt="Sign in with Linked In"
                          style={{ maxWidth: '180px', cursor: 'pointer', marginBottom: 12 }}
                      />
              }
              <Box width={900}>
                  {
                      code && userProfile && userProfile.firstName &&
                      <div>
                          <Typography >Welcome: {userProfile.firstName} {userProfile.lastName}</Typography>
                      </div>
                  }
                  { 
                      <TextField id='xmlInput'
                          //label='Enter your workflow XML here'
                          placeholder={instructionsOnUseOfTool}
                          multiline
                          fullWidth
                          inputProps={getStyleForInputXML()}
                          sx={{ backgroundColor: 'lightblue', mt: 1, '& .MuiInputBase-input': { lineHeight: 1.6 }}}
                          margin='normal'
                          color='success'
                          minRows={12}
                          maxRows={12}
                          value={value.xml}
                          onChange={handleXMLChange}
                      />
                  }
                  </Box>
              {
                  showProgress === true &&
                  <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                  </Box>
              }
              {
                <Typography variant="caption" align="center" sx={{ mt: 1, color: '#FFC857' }}>
                For XMLs over 5 MB, email us at <Link color='#FFC857' href='mailto:contact@agility1st.com'>contact@agility1st.com</Link>.
                Please review/test all generated SQLs.
                </Typography>
              }
              {
                  <Box height={40} marginTop={3}>
                    <Stack direction='row' spacing={3}>
                        <Chip color='primary' label='Generate Spark SQL' onClick={handleSparkClick} />
                        <Chip color='primary' label='Clear Input' onClick={handleReset} />
                        <Chip color='primary' label='Generate Snowflake SQL' onClick={handleSnowflakeClick} />
                    </Stack>
                  </Box>
              }
              {
                <Box height={40} marginTop={2}>
                    <Stack direction='row' spacing={10}>
                        <Link href="https://agility1st.com/terms-of-use-disclaimer/" underline="hover" target="_blank" rel="noopener"><Typography color='#00aaaa'>Terms of Use & Disclaimer</Typography></Link>
                        <Link href="https://agility1st.com/learn-how-w2sql-works/" underline="hover" target="_blank" rel="noopener"><Typography color='#00aaaa'>Export workflow XML (blog)</Typography></Link>
                    </Stack>
                </Box>
              }
              {
                  //Original divider had used flexItem and color was not used
                  <Divider color='#FFFFFF' orientation='horizontal' sx={{ height: 1, width: '900px', margin: 1 }} />
              }
              {
                  value.isSuccessful !== undefined && value.isSuccessful &&
                  <OutputItems data={value} />
              }
              {
                /*
                  (value.isSuccessful === undefined || value.isSuccessful === false) &&
                  <div>
                      <Chip color='primary' label='Infographic Video' onClick={handleShowDemo} />
                  </div>
                */
              }
              {     
                  //<InformationDisplay flag={value.isSuccessful === undefined ? "none" : !value.isSuccessful ? "error" : value.needProperAuth ? "info" : "success"} />
                  <ErrorMessageDisplay flag={value.isSuccessful === undefined ? "none" : value.needProperAuth ? "5001" : value.needsCorporateLogin ? "9001" : "success"} />
                }
              {
                  <ErrorMessageDisplay flag={value.exception === undefined ? "none" : value.exception} />
              }
          </div>
    </div>
  );
}

export default AppMain;

//                      <Typography>Powered by <a href='htttp://www.agility1st.com'>Agility1st, Inc</a></Typography>

